import React, { useState, useEffect } from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";

const RangeSlider = ({ radius = 200, handleComplete }) => {
  const [value, setValue] = useState(radius);

  const handleSliderChange = (newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(radius);
  }, [radius]);

  return (
    <div>
      <div className="range_s">
        <h4 className="heading-slider">Set Radius (Miles)</h4>
        <InputRange
          minValue={0}
          maxValue={200}
          value={value}
          onChange={handleSliderChange}
          onChangeComplete={handleComplete}
          formatLabel={(val) => `${val}`}
          draggableTrack
        />
      </div>
    </div>
  );
};

export default RangeSlider;
